// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"d8-z","disabled":"e8-z","label":"f8-z"};